module.exports = __webpack_public_path__ + "assets/img/pages/partners/kfb_color_active.png";